module.exports = __webpack_public_path__ + "img/create.b52d73ff.webp";